// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contractor-container {
  margin-bottom: 15px;
  background: #f9f9f9;
  border-radius: 5px;
}

.contractor-header {
  padding: 15px 20px;
  cursor: pointer;
  font-weight: bold;
  color: #0e0635;
  transition: background-color 0.3s;
}

.contractor-header:hover {
  background-color: #e8e8e8;
}

.contractor-details {
  padding: 20px;
  border-top: 1px solid #ddd;
}

.info-section,
.users-section,
.restaurants-section {
  margin-bottom: 20px;
}

.info-section h3,
.users-section h3,
.restaurants-section h3 {
  color: #34495e;
  margin-bottom: 10px;
}

ul {
  list-style-type: none;
  padding-left: 0;
}

li {
  margin-bottom: 8px;
}

.restaurant-name {
  cursor: pointer;
  color: #2980b9;
  transition: color 0.3s;
}

.restaurant-name:hover {
  color: #3498db;
}

.restaurant-fops {
  margin-top: 10px;
  padding-left: 20px;
}



.admin-panel {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
}

h1 {
  text-align: center;
  color: #333;
}

h2 {
  margin-top: 30px;
  color: #555;
}

.search-section,
.message-section {
  background: #f5f5f5;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

input,
textarea {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

button {
  background: #4CAF50;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin: 5px;
}

button:hover {
  background: #45a049;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th,
td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
}

th {
  background-color: #4CAF50;
  color: white;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.loading {
  text-align: center;
  padding: 50px;
  font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./src/components/directory/Directory.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;;;AAIA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB","sourcesContent":[".contractor-container {\r\n  margin-bottom: 15px;\r\n  background: #f9f9f9;\r\n  border-radius: 5px;\r\n}\r\n\r\n.contractor-header {\r\n  padding: 15px 20px;\r\n  cursor: pointer;\r\n  font-weight: bold;\r\n  color: #0e0635;\r\n  transition: background-color 0.3s;\r\n}\r\n\r\n.contractor-header:hover {\r\n  background-color: #e8e8e8;\r\n}\r\n\r\n.contractor-details {\r\n  padding: 20px;\r\n  border-top: 1px solid #ddd;\r\n}\r\n\r\n.info-section,\r\n.users-section,\r\n.restaurants-section {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.info-section h3,\r\n.users-section h3,\r\n.restaurants-section h3 {\r\n  color: #34495e;\r\n  margin-bottom: 10px;\r\n}\r\n\r\nul {\r\n  list-style-type: none;\r\n  padding-left: 0;\r\n}\r\n\r\nli {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.restaurant-name {\r\n  cursor: pointer;\r\n  color: #2980b9;\r\n  transition: color 0.3s;\r\n}\r\n\r\n.restaurant-name:hover {\r\n  color: #3498db;\r\n}\r\n\r\n.restaurant-fops {\r\n  margin-top: 10px;\r\n  padding-left: 20px;\r\n}\r\n\r\n\r\n\r\n.admin-panel {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\nh1 {\r\n  text-align: center;\r\n  color: #333;\r\n}\r\n\r\nh2 {\r\n  margin-top: 30px;\r\n  color: #555;\r\n}\r\n\r\n.search-section,\r\n.message-section {\r\n  background: #f5f5f5;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\ninput,\r\ntextarea {\r\n  width: 100%;\r\n  padding: 10px;\r\n  margin: 10px 0;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n}\r\n\r\nbutton {\r\n  background: #4CAF50;\r\n  color: white;\r\n  padding: 10px 20px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  margin: 5px;\r\n}\r\n\r\nbutton:hover {\r\n  background: #45a049;\r\n}\r\n\r\ntable {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin-top: 20px;\r\n}\r\n\r\nth,\r\ntd {\r\n  border: 1px solid #ddd;\r\n  padding: 12px;\r\n  text-align: left;\r\n}\r\n\r\nth {\r\n  background-color: #4CAF50;\r\n  color: white;\r\n}\r\n\r\ntr:nth-child(even) {\r\n  background-color: #f2f2f2;\r\n}\r\n\r\n.loading {\r\n  text-align: center;\r\n  padding: 50px;\r\n  font-size: 18px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
